import {
  ThematicPackageBudgetTierResponse,
  ThematicPackageCustomBudgetResponse,
} from '@features/campaigns/shared/types/campaignSubmit.ts';
import { CustomBudgetBounds } from '@features/campaigns/thematicPackage/types/thematicPackage.types.ts';
import { isKnownBudgetTier } from '@features/campaigns/thematicPackage/utils/isKnownBudgetTier.ts';

// A custom amount is how the user goes beyond the preset tiers, so its floor is the highest tier on
// offer. The API only rejects amounts below the cheapest tier, so the stricter of the two wins.
export function resolveCustomBudgetBounds(
  budgetTiers: ThematicPackageBudgetTierResponse[] = [],
  customBudget?: ThematicPackageCustomBudgetResponse,
): CustomBudgetBounds | undefined {
  if (!customBudget) {
    return undefined;
  }

  const highestPresetAmount = budgetTiers
    .filter(isKnownBudgetTier)
    .reduce((highest, { amount }) => Math.max(highest, amount), 0);

  return {
    minimumAmount: Math.max(highestPresetAmount, customBudget.minimumAmount),
    maximumAmount: customBudget.maximumAmount,
  };
}

export function isCustomBudgetAmountWithinBounds(amount: number | null, bounds?: CustomBudgetBounds): boolean {
  if (amount === null || !bounds) {
    return false;
  }

  if (amount < bounds.minimumAmount) {
    return false;
  }

  return bounds.maximumAmount === null || amount <= bounds.maximumAmount;
}
